import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    pickSlipOuter: {
        height: 'calc(100% - 64px)',
        top: '64px',
        position: 'relative'
    },
    pickSlipContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'space-between'
    },
    pickSlipSection: {
        display: 'inline-block',
        verticalAlign: 'top',
        marginLeft: '10px'
    },
    opened: {
        marginLeft: '10px',
        width: 'calc(100% - 310px)'
    },
    closed: {
        width: 'calc(100% - 20px)',
        marginLeft: '20px'
    }
});
